import { createClient } from '@supabase/supabase-js';

const url  = import.meta.env.VITE_SUPABASE_URL;
const key  = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  console.warn('[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY not set');
}

// Bypass navigator.locks — avoids NavigatorLockAcquireTimeoutError when
// multiple tab contexts or a single shared client compete for the same lock.
// Safe: a single client instance handles token refresh sequencing internally.
const noLock = (_name, _timeout, fn) => fn();

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    lock: noLock,
  },
});
